import { inject, Injectable, Type } from '@angular/core';
import { AlertDialogComponent } from '../dialogs/alert-dialog.component';
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog.component';
import { DialogType } from '../dialogs/dialog-type.model';
import { OverlaysService } from '../overlays';


@Injectable({
    providedIn: 'root',
})
export class ModalsService {

    protected overlaysService = inject(OverlaysService);

    openModal<T>(modalComponent: Type<T>, inputs?: Partial<T> | Record<string, unknown>) {
        return this.overlaysService.createOverlay(modalComponent, { inputs });
    }

    alert(content: string, header = 'Notification', type: DialogType = 'info') {
        return this.openModal(AlertDialogComponent, { type, header, content });
    }

    confirm(message: string, header = 'Question', type: DialogType = 'info') {
        return this.openModal(ConfirmDialogComponent, { type, header, content: message });
    }
}
